import { Button, SortHeader } from './ui'

/** Piccolo link "Ordine predefinito", visibile solo quando l'ordinamento scelto non e' quello di default. */
export function SortResetLink({
  sort,
  defaultSort,
  onReset,
}: {
  sort: string
  defaultSort: string
  onReset: () => void
}) {
  if (sort === defaultSort) return null
  return (
    <Button variant="text" size="sm" onClick={onReset}>
      Ordine predefinito
    </Button>
  )
}

/**
 * F-101 (REQ-277-001): intestazione ordinabile per le liste di Finance, Operations e Settings, dove le chiavi
 * di `sort` ammesse dal backend non seguono sempre `<campo>_asc|_desc` (es. `status`, `priority`, `name`,
 * `start_asc` come default). Si passa la chiave crescente e, se esiste, quella decrescente: il click alterna,
 * altrimenti riporta alla chiave unica. Come `SortableTh` (F-095) per aspetto e accessibilita'.
 */
export function SortKeyTh({
  label,
  ascKey,
  descKey,
  sort,
  onSort,
  className,
}: {
  label: string
  ascKey: string
  descKey?: string
  sort: string
  onSort: (next: string) => void
  className?: string
  title?: string
}) {
  const isAsc = sort === ascKey
  const isDesc = descKey !== undefined && sort === descKey
  const next = isAsc && descKey ? descKey : ascKey
  return (
    <SortHeader
      label={label}
      sortKey={ascKey}
      activeKey={isAsc || isDesc ? ascKey : null}
      direction={isDesc ? 'desc' : 'asc'}
      onSort={() => onSort(next)}
      className={className}
    />
  )
}
